import { Report_ValueType } from "@/services/graphql/reactQuery";
import { PaxBoxElementProps, PaxElementWrapperProps } from "@ncino/pax-ui";
import { PaxListElementProps } from "../components/elements/PaxListElement";
import { PaxTableElementProps } from "../components/elements/PaxTableElement";

export enum ColumnType {
  Boolean = "BOOLEAN",
  Date = "DATE",
  Link = "LINK",
  Number = "NUMBER",
  String = "STRING",
  JSX = "JSX",
}

export interface PaxTableColumnHeader {
  align?: "left" | "right" | "center";
  jsx?: JSX.Element;
  children?: PaxTableColumnHeader[] | null;
  colSpan?: number | null;
  displayName: string;
  rowSpan?: number | null;
  sortable?: boolean | null;
  type?: ColumnType | null;
  fieldName?: string | null;
}

// default/alternate apply to striped table rows...since we want table subgroups to always follow the
// subheader with a white row, we can't rely on the "striped" property of the table component
// default/alternate apply to striped table rows...since we want table subgroups to always follow the
// subheader with a white row, we can't rely on the "striped" property of the table component
export enum RowClass {
  SUBHEADER = "subheader",
  SUBTOTAL = "subtotal",
  TOTAL = "total",
  DEFAULT = "default",
  ALTERNATE = "alternate",
  SUBTOTAL_ALTERNATE = "subtotal_alternate",
}

export interface PaxTableCell {
  jsx?: JSX.Element | null;
  altSortKey?: number | null;
  bold?: boolean | null;
  children?: PaxTableCell[] | null;
  colClass?: string | null;
  colSpan?: number | null;
  displayValue?: string | null;
  hoverText?: string | null;
  href?: string | null;
  rowSpan?: number | null;
  sortKey?: number | null;
  value?: string | null;
  valueType?: Report_ValueType | null;
  rowClass?: RowClass | null;
}

export interface PaxTableRow {
  cells: PaxTableCell[];
  cssId?: string | null;
  rowClass?: string | null;
}

export type TableElementStatus = "COMPLETED" | "FAILED" | "PROCESSING" | "QUEUED";

export interface TableData {
  headers: PaxTableColumnHeader[];
  rows?: PaxTableRow[];
}

export interface ReportElementData {
  requestId: string;
  status: TableElementStatus;
  tableData?: TableData | null;
  chartData?: string[] | null;
  notes?: string[];
  truncated: boolean | null;
  numStrats?: number | null;
  error: any;
  debugSqlStrings?: string[];
}

export enum SortDirection {
  ASCENDING = 1,
  DESCENDING = -1,
}

export type AxisRounding = "none" | "thousands" | "millions" | "billions";

export interface AxisFormat {
  label?: string;
  precision?: number;
  tickPrecision?: number;
  rounding?: AxisRounding;
  suffix?: string;
  allowDecimals?: boolean;
}

export interface ChartElementProps {
  axisFormats?: AxisFormat[];
  categoryLabels?: string[];
  chartHeight?: number;
  showLegend?: boolean;
  pointWidth?: number;
}

export interface ElementConfig {
  props?: PaxElementWrapperProps &
    (PaxTableElementProps | PaxListElementProps | Partial<PaxBoxElementProps>) &
    ChartElementProps;
  elementData?: ReportElementData;
  key?: string;
  onErrorAction?: () => void;
}
